import { get } from "lodash";
import { StageDMessageInfo, StageDocumentsInfo } from "../stage-d/Review-Application.class";

export class SolicitorCorrespondenceResponse {
  application_uuid: string;
  message_info: StageDMessageInfo[];
  folders: StageDocumentsInfo[];
  additional_document_selections: {
      label: string;
      code: string;
  }[];


  constructor(initial?: SolicitorCorrespondenceResponse){
    this.application_uuid = get(initial, 'application_uuid', "");
    this.message_info = get(initial, 'message_info', []);
    this.folders = get(initial, 'folders', []);
    this.additional_document_selections = get(initial, 'additional_document_selections', []);
  }
}

